
































import Vue, { PropType } from "vue"
import PSampleProfile from "../../../../guideline/util/PSampleProfile.vue"
import { DESCRIPTION_ICON } from "~/config/icon"
import SectionTitle from "~/components/guideline/util/SectionTitle.vue"
import RowGroup from "~/components/guideline/util/RowGroup.vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"

interface Capability {
  key: string
  title: string
  description: string
}

export default Vue.extend({
  components: {
    SectionTitle,
    RowGroup,
    ColumnWithIcon,
    EditItemDescription,
    PSampleProfile,
  },
  props: {
    capabilities: {
      type: Array as PropType<Capability[]>,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        description: DESCRIPTION_ICON,
      },
      sampleText: `■サンプル①
マーケティングにおいて、戦略の立案、KPIの策定などの上流から、WEB広告の運用（リスティング広告、GDN、YDA、SNS広告など）などの実務経験があります。ベンチャー企業において、マーケティング組織を構築することを得意としています。

■サンプル②
WEBアプリケーション開発：要件定義・設計・実装・テスト等の工程において、それぞれ3年以上の実務経験があります。

■サンプル③
WEBデザイン、グラフィックデザインを駆使し、届けたいターゲットやペルソナに最適なデザイン設計ができます。`,
    }
  },
  computed: {
    editLinkForSectionTitle(): string {
      if (!this.isEditable) {
        return ""
      }
      return "/profiles/edit/capability"
    },
  },
})
